import { Backdrop, CircularProgress, Box } from '@mui/material'
import { darken } from '@mui/material/styles'

const LoadingOverlay = ({ props: viewProps = {} }) => {
  const { open } = viewProps
  return (
    <Backdrop
      open={Boolean(open)}
      sx={(theme) => ({
        zIndex: theme.zIndex.modal + 2,
        backgroundColor: 'rgba(255, 255, 255, 0.55)',
        backdropFilter: 'blur(1px)'
      })}
    >
      <Box
        sx={(theme) => ({
          width: 96,
          height: 96,
          borderRadius: theme.shape.borderRadius * 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255,255,255,0.35)',
          boxShadow: `0 10px 30px ${darken(theme.custom?.keysys?.blue || theme.palette.primary.main, 0.3)}33`
        })}
      >
        <CircularProgress
          size={58}
          thickness={4.2}
          sx={(theme) => ({
            color: theme.custom?.keysys?.blue || theme.palette.primary.main
          })}
        />
      </Box>
    </Backdrop>
  )
}

export { LoadingOverlay }
